// Access the strings used on the password page.
export const t_password = {
  title: "login.password.title",
  subtitle: "login.password.subtitle",
  passwordPlaceholder: "login.password.passwordPlaceholder",
  forgotPasswordLink: "login.password.forgotPasswordLink",
  securityWarning: "login.password.securityWarning",
  securityWarningLink: "login.password.securityWarningLink",
};
